<script lang="ts">
    import GameCard from 'src/components/main/#common/game-card/GameCard.svelte'
    import mergeCatsImage from 'src/components/main/#assets/game-merge-cats.jpg'
    import cryptoDragons from 'src/components/main/#assets/game-crypto-dragons.jpg'
    import cryptoFox from 'src/components/main/#assets/game-crypto-fox.jpg'
    import cryptoDoge from 'src/components/main/#assets/game-crypto-doge.jpg'
    import elonGame from 'src/components/main/#assets/game-elon-game.jpg'
    import cryptoPepe from 'src/components/main/#assets/crypto-pepe-game.jpg'
    import elementalWars from 'src/components/main/#assets/game-elemental-wars.jpg'
    import {Link} from 'svelte-routing'
    import {api} from "../../../../../services/api/reallis"
</script>

<section class="game-cards" id="game-cards">
    <div class="container">
        <div class="title">Our games</div>
        <div class="description">Enjoy interesting gameplay and get valuable currency</div>
        <div class="main-intro-games">
            <div class="row">
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Crypto Cats"
                        rating="4.5"
                        reviews="120 943"
                        image={mergeCatsImage}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.soul.merge.cat.cute.simulator.adventure"
                    />
                </div>
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Crypto Dragons"
                        rating="4.4"
                        reviews="124 433"
                        image={cryptoDragons}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.dragons.tokens.crypto"
                    />
                </div>
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Crypto Fox"
                        rating="4.7"
                        reviews="2 347"
                        image={cryptoFox}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.realis.fox.nft.token"
                    />
                </div>
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Crypto DOGE"
                        rating="4.5"
                        reviews="5 493"
                        image={cryptoDoge}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=elon.musk.doge.meme.blockchain.coin.twit"
                    />
                </div>
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Elon Game"
                        rating="4.7"
                        reviews="1 559"
                        image={elonGame}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.realis.elon.nft.token"
                    />
                </div>
                <div class="col-6 col-md-4">
                    <GameCard
                        title="Crypto Frepe"
                        rating="4.7"
                        reviews="127"
                        image={cryptoPepe}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=com.frog.meme.token"
                    />
                </div>
                <!--
                <div class="col-md-4">
                    <GameCard
                        title="Elemental Wars"
                        rating="*"
                        reviews="*"
                        image={elementalWars}
                        published={true}
                        link="https://play.google.com/store/apps/details?id=elemental.battler.nft.card.meowgon"
                    />
                </div>
                -->
            </div>
        </div>
    </div>
</section>

<style>
    .game-cards {
        padding-top: 86px;
    }

    .title {
        font-family: 'Anton', sans-serif;
        font-size: 70px;
        font-weight: 400;
        color: white;
        margin: 0 0 30px;
        line-height: 90px;
        text-align: center;
    }

    .description {
        color: #CED5E3;
        font-size: 20px;
        text-align: center;
        margin-bottom: 100px;
        line-height: normal;
    }

    .title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .game-link img {
        max-width: 100%;
    }

    .game-reviews span {
        color: #515159;
        padding-left: 2px;
    }

    .main-intro :global(svg.star-icon) {
        font-size: 14px;
        color: #F3BD38;
        vertical-align: top !important;
        margin: 5px 0 0 0;
    }

    .main-intro :global(svg.star-icon:first-child) {
        margin-left: 5px;
    }

    @media(max-width: 1199px) {
        .title {
            font-size: 50px;
            line-height: 70px;
        }
    }

    @media (max-width: 992px) {
        .title {
            font-size: 50px;
            line-height: 70px;
            margin: 0 0 40px;
        }

        .description {
            margin-bottom: 70px;
        }

        .game-cards {
            padding-top: 100px;
        }
    }

    @media (max-width: 767px) {
        .title {
            font-size: 40px;
            line-height: 60px;
            margin: 0 0 30px;
        }

        .description {
            font-size: 16px;
            margin-bottom: 50px;
        }

        .game-cards {
            padding-top: 70px;
        }
    }
</style>
